/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { toast } from 'sonner'

// Style UltyToast to match style of previous toasts
const UltyToast = ({
                       type,
                       title,
                       jsx,
                   }) => {
    return (
      <div
        css={css`
            cursor: pointer;
            pointer-events: all;
            display: flex;
            place-self: center;
            background-color: ${type === 'success' ?
                    'rgb(85, 202, 146)' :
                    type === 'error' ?
                            'rgb(232, 87, 66)' :
                            '#d9d9d9'
            };
            padding: 10px 30px;
            color: white;
            border-radius: 0 0 4px 4px;
            text-align: center;
        `}
      >
          {jsx ? jsx() : title}
      </div>
    )
}

const ultyToast = ({
                       type,
                       title,
                       jsx,
                       dismissible,
                       duration,
                   }) => {
    toast.custom((id) => (
      <UltyToast
        id={id}
        type={type}
        title={title}
        jsx={jsx}
      />
    ), {
        dismissible: dismissible !== undefined ? dismissible : true,
        duration: duration !== undefined ? duration : 4000,
        toasterId: 'ulty-toast',
    })
}


export { UltyToast, ultyToast }
